import React, { useState, useEffect } from "react";
import { Loader2, ImageOff } from "lucide-react";
import { caiApi } from "../api";

interface MdDownloadImageProps {
  src: string;
  alt?: string;
}

/**
 * Renders images from md_download paths by fetching via authenticated API.
 * Shows loading spinner while fetching, error state on failure.
 */
export function MdDownloadImage({ src, alt }: MdDownloadImageProps) {
  const [blobUrl, setBlobUrl] = useState<string | null>(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    let cancelled = false;

    caiApi
      .fetchMdDownload(src)
      .then((url) => {
        if (!cancelled) setBlobUrl(url);
      })
      .catch(() => {
        if (!cancelled) setError(true);
      });

    return () => {
      cancelled = true;
    };
  }, [src]);

  if (error) {
    return (
      <div className="flex items-center gap-2 text-text-muted text-[11px] py-2">
        <ImageOff size={14} />
        <span>Failed to load image</span>
      </div>
    );
  }

  if (!blobUrl) {
    return (
      <div className="flex items-center gap-2 text-text-muted text-[11px] py-2">
        <Loader2 size={14} className="animate-spin" />
        <span>Loading image...</span>
      </div>
    );
  }

  return (
    <img
      src={blobUrl}
      alt={alt ?? "Generated image"}
      className="max-w-full rounded-lg my-2 border border-border-subtle"
    />
  );
}
